import $ from 'jquery';
import Utils from '../../../utils';
export default class ListAjaxFilter {
    xhrRequest = null;
    $list;
    $listItems;
    $contentLoader;
    $emptyDataMessage;
    $errorMessage;
    isListItemWrapped;
    constructor(listSelector, listItemsSelector, contentLoaderSelector, emptyDataMessageSelector, isListItemWrapped) {
        this.$list = $(listSelector);
        this.$listItems = this.$list.find(listItemsSelector);
        this.$contentLoader = $(contentLoaderSelector);
        this.$emptyDataMessage = $(emptyDataMessageSelector);
        this.$errorMessage = $(this.$list.data('error-message-selector'));
        this.isListItemWrapped = isListItemWrapped;
        this.filterList();
    }
    filterList() {
        const url = this.$list.data('filter-url');
        if (this.$list.length) {
            if (this.xhrRequest) {
                this.xhrRequest.abort();
                this.xhrRequest = null;
            }
            Utils.contentLoader(this.$contentLoader, true);
            this.xhrRequest = $.ajax({
                url,
                method: 'GET',
                data: [],
                cache: false,
            })
                .done(data => {
                if (this.isListItemWrapped) {
                    this.$listItems.parent().hide();
                }
                else {
                    this.$listItems.hide();
                }
                this.$listItems.each((index, element) => {
                    let $element;
                    if (this.isListItemWrapped) {
                        $element = $(element).parent();
                    }
                    else {
                        $element = $(element);
                    }
                    data.forEach((item) => {
                        if (item.id == $element.find(`input`).val()) {
                            $element.show();
                        }
                    });
                    this.$emptyDataMessage.toggle(!data.length);
                });
                this.$list.show();
                this.$list.find('input:checked').trigger('change');
            })
                .fail(() => {
                if (this.$errorMessage.length) {
                    this.$errorMessage.show();
                }
            })
                .always(() => {
                Utils.contentLoader(this.$contentLoader, false);
            });
        }
    }
}
